module.exports = __webpack_public_path__ + "img/p2-26.cae4122b.png";